import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  HostListener
} from '@angular/core';
import {
  SlickCarouselComponent
} from 'ngx-slick-carousel';
import {
  ApiService
} from '../api.service';
import {
  Router,
  RouterModule
} from '@angular/router';
import {
  GlobalServices
} from '../global.services';
import {
  Meta,
  Title
} from '@angular/platform-browser';
declare var $;
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  public showMonthlyPlan: boolean = false; //set month plan
  public showYearPlan: boolean = true; //set year plan
  public getPlanData: Array < any >= [];
  public planArray = ['monthly', 'yearly'];
  public showAlert: boolean = false;
  public responseMessage: string = "";
  public selectedcard: any = {
    'plan': {
      'ind': '',
      'data': '',
      'currentPlan': ''
    }
  };
  public currentSelectionType = 'yearly';
  slideConfig = {}; //slick config
  slideConfigMembers = {}; //slick config
  slideConfigs = {};
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  @ViewChild('slickModalMembers') slickModalMembers: SlickCarouselComponent;
  @ViewChild('slickModals') slickModals: SlickCarouselComponent;
  @HostListener('window:resize', ['$event']) onResize(event) {
    if (this.globalServices.isBrowser) {
      if(document.getElementsByClassName('carousel')){
      $('.carousel').slick('resize');
      $('.carousel').slick("setPosition", 0);
      }
    }
  }

  constructor(public apiService: ApiService, public router: Router, public viewContainerRef: ViewContainerRef, public cfr: ComponentFactoryResolver, public globalServices: GlobalServices, public title: Title, public meta: Meta) {
    //slick slider config
    if (this.globalServices.isLoggedIn) {
      this.router.navigate(['/plan']);
    }
    if (this.globalServices.isBrowser) {
      this.slickSlider();
      this.updateTitle("Signup & Subscription Pricing | MyLIfeWell");
      this.updateDescription('Join MyLifeWell and reconnect with your inner self. Enjoy member-only benefits and get access to the best in online wellness content, travel, and products. Sign up today!');
    }
  }
  
  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  updateDescription(desc: string) {
    this.meta.updateTag({
      name: 'description',
      content: desc
    })
  }
  public slickSlider() {
    this.slideConfig = {
      "slidesToShow": 3,
      "slidesToScroll": 1,

      "infinite": true,
      "arrows": true,
      "responsive": [{
          breakpoint: 1139,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
        {
          breakpoint: 879,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
      ]
    };
  }

  public slickSliderMembers() {
    this.slideConfigMembers = {
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "dots": "false",
      "infinite": true,
      "responsive": [{
          breakpoint: 1139,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 879,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
      ]
    };
  }

  next() {
    this.slickModalMembers.slickNext();
  }
  prev() {
    this.slickModalMembers.slickPrev();
  }
  ngOnInit(): void {
    if (this.globalServices.isBrowser){
      setTimeout(() => {
       window.scrollTo(0, 0);        
      }, 500);
      this.showPlan('', this.currentSelectionType);
    }
  }

  chnageCard(event, key, i, data, crousel) {
    if (this.globalServices.isBrowser) {
      if (!event.target.closest('.subscription-box').classList.contains('effect') || crousel == 0) {
        if ((this.selectedcard && this.selectedcard[key])) {
          this.selectedcard[key] = {
            'ind': i,
            'data': data,
            'currentPlan': i
          };
        } 
        else {
          this.selectedcard = {
            ...this.selectedcard,
            [key]: {
              'ind': i,
              'data': data,
              'currentPlan': i
            },
          };
        }
      } else {
        this.selectedcard[key] = {
          ind: "",
          data: "",
          currentPlan: ""
        };
      }
      this.redirectTosubscription(data);
    }
  }

  redirectTosubscription(data){
  this.router.navigate(['/subscribe',data._id+'-'+data.subscriptionType])
  }
  //show Plan tabbing
  public monthData: any = [];
  public customPlanData: any = [];
  public planName: any = ['plan'];
  public response: any = [];
  showPlan(event, str) {
    if (this.globalServices.isBrowser) {
      this.getPlanData = [];
      this.planName = ['plan'];
      this.customPlanData = [];
      if (this.slickModal)
        this.slickModal.unslick();
      if (str) {
        this.getPlanData = [];
        this.customPlanData = [];
        this.selectedcard = {
          'plan': {
            'ind': '',
            'data': '',
            'currentPlan': ''
          }
        };
        let url = 'billingservice/subscription/detail/all';
        let data = {
          'slug': 'global'
        };
        this.apiService.postbillData(url, data).subscribe((res) => {
          if (res && res['data'] && res['data']) {
            let response: any = res['data'];
            this.response = res;
            let data = response.filter(function (e) {
              return e.subscriptionType === str;
            });

            // this.getPlanData = data[0]['subsPlans'];
            this.getPlanData = data[0]['subsPlans'].filter(function (e) {
              return e['planDurationObject']['price'] >0;
            });
            this.customPlanData = res['customPlanData'];
            for (let i = 0; i < res['customPlanData'].length; i++) {
              let obj = res['customPlanData'][i];
              this.planName.push(obj['name'])
              for (let j = 0; j < obj['subsPlans'].length; j++) {
                if (obj['subsPlans'][j]['isCurrentPlan'] == 1) {
                  this.selectedcard = {
                    ...this.selectedcard,
                    [obj['name']]: {
                      'ind': i + 1,
                      data: obj['subsPlans'][j],
                      'currentPlan': j
                    }
                  };
                  break;
                } else {
                  this.selectedcard = {
                    ...this.selectedcard,
                    [obj['name']]: {
                      'ind': '',
                      data: '',
                      'currentPlan': ''
                    }
                  };
                }
              }
            }
            for (let i = 0; i < this.getPlanData.length; i++) {
              if (this.getPlanData[i]['isCurrentPlan'] == 1) {
                this.selectedcard['plan'] = {
                  ind: 0,
                  data: this.getPlanData[i],
                  'currentPlan': i
                };
                break;
              } else {
                this.selectedcard['plan'] = {
                  ind: '',
                  data: '',
                  'currentPlan': ''
                };
              }
            }

            if (this.currentSelectionType == 'monthly') {
              this.monthData = [];
              for (let obj of this.getPlanData) {
                this.monthData.push({
                  'key': obj['name'],
                  'total': obj['planDurationObject']['price'] * 12
                });
              }
            }
          }
        }, (error) => {
          throw error('something went wrong!');
        })
      }
    }
  }

  public showPlanDefault(str): void {
    if (this.globalServices.isBrowser) {
      if ($('#' + str).hasClass('active')) {
        return;
      }
      this.getPlanData = [];
      this.planName = ['plan'];
      if (this.slickModal)
        this.slickModal.unslick();
      if (str == 'monthly') {
        this.currentSelectionType = 'monthly';
        this.showMonthlyPlan = true;
        this.showYearPlan = false;
        localStorage.removeItem('planpayment');
        localStorage.removeItem('dataArray');
      } else {
        this.currentSelectionType = 'yearly';
        this.showYearPlan = true;
        this.showMonthlyPlan = false;
        localStorage.removeItem('planpayment');
        localStorage.removeItem('dataArray');
      }
      setTimeout(() => {
        if (str) {
          this.getPlanData = [];
          this.selectedcard = {};
          let userToken = localStorage.getItem('userToken');
          // if (userToken) {
          let data = this.response['data'].filter(function (e) {
            return e.subscriptionType === str;
          });
          // this.getPlanData = data[0]['subsPlans'];
          this.getPlanData = data[0]['subsPlans'].filter(function (e) {
            return e['planDurationObject']['price'] >0;
          });
          this.customPlanData = this.response['customPlanData'];
          for (let i = 0; i < this.response['customPlanData'].length; i++) {
            let obj = this.response['customPlanData'][i];
            this.planName.push(obj['name'])
            for (let j = 0; j < obj['subsPlans'].length; j++) {
              if (obj['subsPlans'][j]['isCurrentPlan'] == 1) {
                this.selectedcard = {
                  ...this.selectedcard,
                  [obj['name']]: {
                    'ind': i + 1,
                    data: obj['subsPlans'][j],
                    'currentPlan': j
                  }
                };
                break;
              } else {
                this.selectedcard = {
                  ...this.selectedcard,
                  [obj['name']]: {
                    'ind': '',
                    data: '',
                    'currentPlan': ''
                  }
                };
              }
            }
          }
          for (let i = 0; i < this.getPlanData.length; i++) {
            if (this.getPlanData[i]['isCurrentPlan'] == 1) {
              this.selectedcard['plan'] = {
                ind: 0,
                data: this.getPlanData[i],
                'currentPlan': i
              };
              break;
            } else {
              this.selectedcard['plan'] = {
                ind: '',
                data: '',
                'currentPlan': ''
              };
            }
          }
          if (this.currentSelectionType == 'monthly') {
            this.monthData = [];
            for (let obj of this.getPlanData) {
              this.monthData.push({
                'key': obj['name'],
                'total': obj['planDurationObject']['price'] * 12
              });
            }
          }
        }
      }, 0);
    }
  }

  opensignupmodal() {
    this.globalServices.viewcontainerhelper = this.viewContainerRef;
    this.globalServices.triggersignup(this.viewContainerRef, this.cfr);
  }
  public submitPlan(selectedPlandata: any, price: any, finalprice: any): void {
    if (this.globalServices.isBrowser) {
      if (price == 0) {
        this.globalServices.priceCheck = {
          price: price,
          free: 'nonLoginFreeTrial'
        };
        if (!this.globalServices.isLoggedIn) {
          this.opensignupmodal();
        } else {
          this.router.navigate(['/confirmation']);
        }
      } else {
        let requireddata = {
          price: selectedPlandata['planDurationObject']['price'],
          userSubscriptionIds: selectedPlandata['_id'],
          subscriptionType: this.currentSelectionType,
          planName: selectedPlandata['name'],
          finalPrice: finalprice
        };
        if (requireddata) {
          if (this.globalServices.isBrowser) {
            this.globalServices.priceCheck = {
              price: price,
              free: 'nonLoginFreeTrial'
            };
            localStorage.setItem('planpayment', JSON.stringify(requireddata));
            if (!this.globalServices.isLoggedIn) {
              this.opensignupmodal();
            } else {
              this.router.navigate(['payment']);
            }
          }
        }
      }
    }
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }
  public submitPlanAllPlanData(): void {
    if (this.globalServices.isBrowser) {
      let data = [];
      for (let i = 0; i < this.planName.length; i++) {
        data.push({
          [this.planName[i]]: this.selectedcard[this.planName[i]],
          name: this.planName[i]
        });
      }
      if (this.selectedcard['plan']['currentPlan'] !== '') {
        localStorage.setItem('dataArray', JSON.stringify(data));
        let requireddata = [];
        let finalprice: any;
        for (let i = 0; i < data.length; i++) {
          if (this.planName[i] == 'plan') {
            if (this.currentSelectionType == 'monthly') {
              finalprice = data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] - ((data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] / 100) * +(data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] ? data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] : 0));
            } else if (this.currentSelectionType == 'yearly') {
              finalprice = ((data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] - ((data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] / 100) * +(data[i][Object.keys(data[i])[0]]['data']['shopDiscount']))) / 12) * 12
            }
          }

          requireddata.push({
            price: (data[i] && data[i][Object.keys(data[i])[0]] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject'] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price']) ? finalprice : (this.planName[i] == 'Wellness Coach') ? (data[i] && data[i][Object.keys(data[i])[0]] && (data[i][Object.keys(data[i])[0]]['data']['planprice'] - ((data[i][Object.keys(data[i])[0]]['data']['planprice'] / 100) * +((data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] !== '') ? data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] : 0))) * data[i][Object.keys(data[i])[0]]['data']['plandur']) : (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planprice'] - ((data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planprice'] / 100) * +(data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] ? data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] : 0))),
            subscriptionId: (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['_id']) || '',
            subscriptionName: (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['name']) || '',
            subscriptionType: (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i][Object.keys(data[i])[0]]['data']['subscriptionType'])?(data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i][Object.keys(data[i])[0]]['data']['subscriptionType']) : data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype']+'ly' : this.currentSelectionType,
            planCategoryId: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planCategoryId'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planCategoryId'] : '',
            activeTriCamp: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['activeTriCamp'],
            triCapmDurStart: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['triCapmDurStart'],
            triCapmDurEnd: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['triCapmDurEnd'],
            isTrial: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrial'],
            noOfDay: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['noOfDay'],
            plandur: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['plandur'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['plandur'] : 1,
            durtype: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] : this.currentSelectionType.substr(0, this.currentSelectionType.length - 2),
            isTrialUsed: (data[i] && data[i][Object.keys(data[i])[0]] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrialUsed'] == undefined || data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrialUsed'] == null) ? 0 : data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrialUsed'],
            occurtype: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['occurtype'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['occurtype'] : '',
            planUsename: this.planName[i],
            
          });
        }
        let count = 0;
        let countToFire = 0;
        let flag = true;
        let priceFlag: boolean = true;
        if (this.globalServices.isBrowser) {
          for (let i = 0; i < requireddata.length; i++) {
            countToFire = countToFire + 1;
            if (requireddata[i]['price'] == '0' || requireddata[i]['price'] == '' || isNaN(requireddata[i]['price'])) {
              count = count + 1;
              if (!this.globalServices.isLoggedIn) {
                if (this.planName.length == countToFire && priceFlag) {
                  this.globalServices.priceCheck = {
                    free: 'confirmation'
                  };
                  this.globalServices.signupType = 'trial';
                  flag = false;
                  this.opensignupmodal();
                }
              } else {
                if (count == this.planName.length) {
                  this.globalServices.priceCheck = {
                    free: 'confirmation'
                  };
                  this.router.navigate(['/confirmation']);
                } else {
                  if (requireddata) {
                    if (this.globalServices.isBrowser) {
                      localStorage.setItem('planpayment', JSON.stringify(requireddata));
                      if (i == (requireddata.length - 1) && priceFlag) {
                        priceFlag = false;
                        this.globalServices.priceCheck = {
                          free: 'payment'
                        };
                        this.globalServices.signupType = 'general';
                        this.router.navigate(['payment']);
                      }
                    }
                  }
                }
              }
            } else {
              if (requireddata) {
                if (this.globalServices.isBrowser) {
                  localStorage.setItem('planpayment', JSON.stringify(requireddata));
                  if (!this.globalServices.isLoggedIn) {
                    if (priceFlag) {
                      priceFlag = false;
                      this.globalServices.priceCheck = {
                        free: 'payment'
                      };
                      flag = false;
                      this.globalServices.signupType = 'trial';
                      this.opensignupmodal();
                    }
                  } else {
                    this.globalServices.signupType = 'general';
                    if (i == (requireddata.length - 1)) {
                      this.globalServices.priceCheck = {
                        free: 'payment'
                      };
                      this.router.navigate(['payment']);
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        this.showAlert = true;
        this.responseMessage = ' Please choose any plan';
      }
    }
  }

  getamount(total, price) {
    if (this.globalServices.isBrowser) {
      return (((total - price) * 100) / total).toFixed(2);
    }
  }

  public accordianChange(index: number): void {
    if (this.globalServices.isBrowser) {
      let els: any = document.getElementsByClassName('accordian');
      if (els) {
        let el: any = document.getElementsByClassName('accordian')[index];
        if (el.classList.contains('active')) {
          el.classList.remove("active");
        } else {
          for (let elem of els) {
            elem.classList.remove("active");
          }
          el.classList.add("active");
        }
      }
    }
  }

  public accordianPlanChange(event, index: number) {
    if (this.globalServices.isBrowser) {
      let els: any = document.getElementsByClassName('subs-wrap');
      if (els) {
        let el: any = document.getElementsByClassName('subs-wrap')[index];

        if (el.getElementsByClassName('subs-content')[0].classList.contains('active')) {
          el.classList.remove("togglearrow");
          el.getElementsByClassName('subs-content')[0].classList.remove("active");
        } else {
          el.classList.add("togglearrow");
          el.getElementsByClassName('subs-content')[0].classList.add("active");
        }
      }
      $('.carousel').slick("setPosition", 0);
    }
  }

  ngDoCheck() {
  }

}
